module.exports = __webpack_public_path__ + "static/media/partager-message.fba7d509.png";